/**
 * Orchestration-related timing and experience constants.
 *
 * Keep in sync with backend/app/agents/orchestration_config.py when values
 * have a backend counterpart (commented inline).
 */

// How often we poll the backend for transcript + status updates (ms)
export const POLL_INTERVAL_MS = 8000;

// SSE staleness: if no transcript event for this long, force reconnect (ms)
export const SSE_STALENESS_MS = 90000;
// How often we check for SSE staleness (ms)
export const SSE_STALENESS_CHECK_MS = 30000;

// Unpinned cards older than this are auto-removed (ms)
export const CARD_EXPIRY_MS = 2 * 60 * 1000; // 2 minutes

// How often the expiry sweep runs (ms)
export const CARD_EXPIRY_CHECK_MS = 30000;
